<template>
  <div class="display-box" >
    <div class="module-layout">
      <!-- <el-select v-model="span" size="mini" style="width:60px;margin:0 10px" @change="changeLayout">
        <el-option value="1">1</el-option>
        <el-option value="2">2</el-option>
        <el-option value="3">3</el-option>
      </el-select>
      <div>行</div> -->
      <el-select v-model="col" size="mini" style="width:60px;margin:0 10px" @change="changeLayout">
        <el-option :value="1">1</el-option>
        <el-option :value="2">2</el-option>
        <el-option :value="3">3</el-option>
        <el-option :value="4">4</el-option>
      </el-select>
      <div>列</div>
      <div style="marginLeft:20px">排版</div>
    </div>
    <draggable
      :group="{ name: 'module', put: true }"
      @add="addModuleItem"
      @update="sortModuleItem"
      :value="moduleItems"
      animation="300"
      class="module-draggable"
      :style="col == 1 ?   'justify-content: center' : ''"
      :ghostClass="`card-items-ghost-${col}`"
    >
      <div
        class="module-items"
        :style="col == 1 ? 'width: 50%' : `width: ${handleWidth(Number(col))}`"
        v-for="(item, index) in moduleItems"
        :key="item.code"
      >
        <!-- <div class="module-item">{{item.title}}
          <i class="el-icon-error" @click="removeModules(item, index)"></i>
        </div> -->
        <div class="module-item" >
          <!--通知公告和校内公文-->
          <p class="flex-box al-c mb10" style="color: #024A84;" v-if="item.code == 'TINFO_NOTICE'  || item.code == 'TINFO_POLICY_FILE' ">
            <img :src="`${baseUrl}images/${item.code}.png`" alt="">
            <span class="ml10 font-14">{{item.title}}</span>
          </p>
          <div v-if="item.code == 'TINFO_NOTICE'">
            <template v-for="(e, i) in noticeList">
              <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item" :key="i" v-if="i<5">
                <span class="flex-1 mr10 ellipsis">{{e.name}}</span>
                <span class="grey">{{e.createTime}}</span>
              </p>
            </template>
            <div v-if="noticeList.length == '0'" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
          </div>
          <div v-if="item.code == 'TINFO_POLICY_FILE'">
            <template  v-for="(e, i) in policyFileList">
              <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">
                <span class="flex-1 mr10 ellipsis">{{e.name}}</span>
                <span class="grey">{{e.createTime}}</span>
              </p>
            </template>
            <div v-if="policyFileList.length == '0'" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
          </div>
          <!--校历-->
          <template  v-if="item.code == 'TINFO_CALENDAR'">
            <schoolDate  :itemData="item"></schoolDate>
          </template>
          <!--便签-->
          <template v-if="item.code == 'TINFO_LABLE'">
            <note :itemData="item"></note>
          </template>
          <!--日程-->
          <template v-if="item.code == 'TINFO_SCHEDULE'">
            <schedule :itemData="item"></schedule>
          </template>
          <!--我的事务-->
          <template v-if="item.code == 'TINFO_AFFAIR'">
            <affair :itemData="item"></affair>
          </template>
          <div v-if="!item.data" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
          <i class="el-icon-error" @click="removeModules(item, index)"></i>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
import schoolDate from './childModules/SchoolDate'
import note from './childModules/Note'
import schedule from './childModules/Schedule'
import affair from './childModules/affair'
import {getCardList} from '@/api/managementCenter/specialManage'
export default {
  name: "card",
  components: { draggable, schoolDate, note, schedule, affair},
  props: ['childModules'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      moduleItems: [],
      span: 1,
      col: 2,
        noticeList: [],
        policyFileList: [],
    };
  },
  created(){
    let subject = this.moduleList.find((item) => {
      return item.cardType === 'CARD'
    })
    if(subject){
      this.moduleItems = JSON.parse(JSON.stringify(subject.cardModules));

      this.col = subject.cardCol
    }
  },
  computed: {
    ...mapGetters(['moduleList']),
  },
  mounted(){
      this.getCardData('0');
      this.getCardData('1');
  },
  methods: {
      getCardData(type){
          let params = {
              type: type || ''
          }
          getCardList(params).then(res =>{
              if(type == '0'){
                  this.noticeList = res.data.data.records
              }
              if(type == '1'){
                  this.policyFileList = res.data.data.records
              }

          })
      },
    changeLayout(){
      // if(this.col * this.span < this.moduleItems.length){
      //   this.moduleItems.length = this.col * this.span
      // }
      this.$emit('caseChanged', true)
    },
    handleWidth(col){
      switch (col) {
        case 1:
          return '100%'
        case 2:
          return '50%'
        case 3:
          return '33.3%'
        case 4:
          return '25%'
        case 5:
          return '20%'
        case 6:
          return '16.6%'
        default:
          return '50%'
      }
    },
    addModuleItem(e){
      // // 判断是否超出个数限制
      // const limit = this.span * this.col;
      // if(this.moduleItems.length >= limit){
      //   this.$message.warning('超出设置的行数,若要继续添加请修改行列数')
      //   return
      // }
      let targetIndex = e.newIndex;
      let childModulesIndex = e.oldIndex;
      let childModule = this.childModules[childModulesIndex];
      // 判断添加的模块是否存在
      // const exist = this.moduleItems.some((item) => {
      //   return item.code === childModule.code;
      // })
      let exist;
      if(this.moduleItems){
        exist = this.moduleItems.some((item) => {
          return item.code === childModule.code;
        })
      }else {
        this.moduleItems = []
        exist = false
      }
      if(exist){
        this.$message.warning('不能重复添加已添加的模块')
        return
      }
      this.moduleItems.splice(targetIndex, 0, childModule);
      this.$emit('caseChanged', true)
    },
    sortModuleItem(e){
      let newIndex = e.newIndex;
      let oldIndex = e.oldIndex;

      let moduleItem = this.moduleItems[oldIndex];
      this.moduleItems.splice(oldIndex, 1);
      this.moduleItems.splice(newIndex, 0, moduleItem);
      this.$emit('caseChanged', true)
    },
    removeModules(item, index){
      this.moduleItems.splice(index, 1)
      this.$emit('caseChanged', true)
    },
    isEmpty(){
      return this.moduleItems.length ? false : true
    },
  },
  watch: {
    moduleItems(val){
      this.$emit('selectedChange', {data:val, module: 'card', col: this.col})
    },
    col(val){
      this.$emit('selectedChange', {data:this.moduleItems, module: 'card', col: this.col})
    }
  },
  filters: {}
}
</script>

<style lang="less">
.module-draggable {
  /*height: 500px;*/
  overflow: scroll;
  background-color: #fff;
  padding: 15px 10px;
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  .card-items-ghost-1 {
    display: inline-block;
    width: 100%;
    height: 170px;
    padding-right: 5px;
    padding-left: 5px;
    margin-bottom: 10px;
    /deep/ .card-item {
      background-color: #F2F3F6;
      padding: 15px;
      width: 100%;
      border: 1px dashed #ccc;
      height: 170px;
      margin: 0;
      .selected {
        display: none;
      }
    }
  }
  .card-items-ghost-2 {
    display: inline-block;
    width: 50%;
    height: 170px;
    padding-left: 5px;
    padding-right: 5px;
    /deep/ .card-item {
      background-color: #F2F3F6;
      padding: 15px;
      width: 100%;
      border: 1px dashed #ccc;
      height: 170px;
      margin: 0;
      .selected {
        display: none;
      }
    }
  }
  .card-items-ghost-3 {
    display: inline-block;
    width: 33.3%;
    height: 170px;
    padding-left: 5px;
    padding-right: 5px;
    /deep/ .card-item {
      background-color: #F2F3F6;
      padding: 15px;
      width: 100%;
      border: 1px dashed #ccc;
      height: 170px;
      margin: 0;
      .selected {
        display: none;
      }
    }
  }
  .card-items-ghost-4 {
    display: inline-block;
    width: 25%;
    height: 170px;
    padding-left: 5px;
    padding-right: 5px;
    /deep/ .card-item {
      background-color: #F2F3F6;
      padding: 15px;
      width: 100%;
      border: 1px dashed #ccc;
      height: 170px;
      margin: 0;
      .selected {
        display: none;
      }
    }
  }
  .card-items-ghost-5 {
    display: inline-block;
    width: 20%;
    height: 170px;
    padding-right: 5px;
    padding-left: 5px;
    /deep/ .card-item {
      background-color: #F2F3F6;
      padding: 15px;
      width: 100%;
      border: 1px dashed #ccc;
      height: 170px;
      margin: 0;
      .selected {
        display: none;
      }
    }
  }
  .card-items-ghost-6 {
    display: inline-block;
    width: 16.6%;
    height: 170px;
    padding-right: 5px;
    padding-left: 5px;
    /deep/ .card-item {
      background-color: #F2F3F6;
      padding: 15px;
      width: 100%;
      border: 1px dashed #ccc;
      height: 170px;
      margin: 0;
      .selected {
        display: none;
      }
    }
  }
  .module-items {
    height: 260px;
    padding: 0 5px 10px;
    .module-item {
      height: 100%;
      background-color: #F2F3F6;
      position: relative;
      // text-align: center;
      // line-height: 170px;
      padding: 15px;
      line-height: 14px;
      cursor: move;
      >i {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #1764A5;
        font-size: 23px;
        cursor: pointer;
      }
      &:hover {
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        .el-icon-error {
          display: block;
        }
      }
      .msg-item {
        cursor: inherit;
      }
    }
  }
}
.module-layout {
  padding-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;

}
.titleClass{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px #e9e9e9 solid;
  padding: 5px 0;
}
</style>